@let currentField = getCurrentField();

<card-base 
    [field]="field()" 
    [type]="type()" 
    [favoriteField]="favoriteField()" 
    [trashField]="trashField()"
    [selected]="selected()" 
    [dynamicActions]="imageActions"
    [overflowTitle]="'document.edit.railLook.photo' | translate">

    <!-- Botão de paleta do rail: "Foto" (tamanho, enquadramento, número e data). O
         "Editar" fica no menu ⋯. Só no editor (lixeira/favoritos não editam). -->
    @if (type() === cardTypes.DEFAULT) {
        <media-look-chip
            card-toolbar
            kind="image"
            [itemId]="currentField?._id"
            [size]="displaySize()"
            [fullImage]="isFullImage()"
            [fillColor]="fillColor()"
            [showNumber]="showImageNumber()"
            [showDate]="showImageDate()"
            [captionStyle]="captionStyle()"
            [captionSide]="captionSide()"
            [canRestore]="lookOverridden()"
            [disabled]="editDataService.documentIsBlocked()"
            (preview)="previewSize($event)"
            (chooseSize)="chooseSize($event)"
            (fullImageChange)="setLook('fullImage', $event)"
            (fillPreview)="previewFill($event)"
            (fillColorChange)="setFill($event)"
            (showNumberChange)="setLook('showImageNumber', $event)"
            (showDateChange)="setLook('showImageDate', $event)"
            (captionStyleChange)="setCaptionStyle($event)"
            (captionSideChange)="setCaptionSide($event)"
            (restore)="restoreLook()"
        />
    }

    <!-- Foto e legenda: o estilo da legenda (cartão, legenda de figura ou faixa) e a
         descrição ao lado espelham a folha do PDF (configs captionStyle e captionPosition). -->
    @let shown = shownSize();
    @let side = captionSide();
    @let singleSize = shown.width === null ? shown.grid : 0;
    @let showNumber = showImageNumber() && imageNumber() !== null;
    @let showDate = showImageDate() && !!currentField.date;
    <div
        class="media-figure"
        [class.style-figure]="captionStyle() === 'figure'"
        [class.style-band]="captionStyle() === 'band'"
        [class.side]="side"
        [style.--media-side-width]="side ? sideWidth() : null">
        <div class="media-body">
            <!-- Image: com tamanho Média/Pequena ou largura livre, vira faixa cinza com a foto
                 centralizada, como no preview e no PDF (single-centered). Ao lado da legenda,
                 a foto ocupa a coluna dela, sem faixa. -->
            <div
                class="container-image"
                [class.single-centered]="!side && (shown.width !== null || shown.grid > 1)"
                [class.size-2]="singleSize === 2"
                [class.size-3]="singleSize === 3"
                [class.custom-size]="shown.width !== null"
                [class.side]="side"
                [style.--image-width]="!side && shown.width !== null ? shown.width + '%' : null"
                [class.full]="isFullImage()"
                [style.--media-fill]="fillStyle()"
                [class.resizing]="resizing()"
                (click)="openFullScreen()">
                <div class="image-box" [sizeMorph]="sizeKey()" sizeMorphMedia="img">
                    <img [src]="currentField.value" />

                    <!-- Cantos da foto: arrastar qualquer um muda o tamanho (a foto é centralizada,
                         então todos fazem o mesmo). Ao lado da legenda a foto fica presa à
                         esquerda, e só os cantos da direita mexem. Só na imagem única, no editor. -->
                    @if (type() === cardTypes.DEFAULT && !editDataService.documentIsBlocked()) {
                        @for (corner of (side ? ['tr', 'br'] : ['tl', 'tr', 'bl', 'br']); track corner) {
                            <span
                                class="resize-corner"
                                [attr.data-corner]="corner"
                                [raEditTooltip]="resizing() ? null : { text: ('document.edit.imageCard.resizeImage' | translate), position: corner[0] === 't' ? 'top' : 'bottom' }"
                                (pointerdown)="startResize($event)"
                                (click)="$event.stopPropagation()">
                            </span>
                        }
                    }

                    @if (resizing()) {
                        <span class="resize-badge">{{ resizeLabel() }}</span>
                    }
                </div>
            </div>
        </div>

        <div class="media-caption">
            <!-- Número e data na primeira linha da legenda (mesma config do preview e do PDF). -->
            @if (showNumber || showDate) {
                <p class="media-caption-head">
                    @if (showNumber) {
                        <span>{{ 'document.preview.imageData.numberLabel' | translate: { num: (imageNumber() | number:'3.0-0') } }}</span>
                    }
                    @if (showNumber && showDate) {
                        <span class="dot" aria-hidden="true">·</span>
                    }
                    @if (showDate) {
                        <span>{{ currentField.date | date:'shortDate' }}</span>
                    }
                </p>
            }

            <!-- Description -->
            <card-description-area [field]="currentField" [readonly]="type() !== 'default'" />
        </div>
    </div>

</card-base>

<!-- Image Editor Component -->
@if (showEditImage()) 
{
    <ra-edit-image 
        [imageUrl]="currentField.value" 
        (close)="showEditImage.set(false)" 
        (imageSaved)="onImageSaved($event)" 
    />
}

<!-- Tela cheia: galeria com todas as imagens da seção, começando nesta -->
@if (showFullScreen())
{
    <ra-images-full-screen
        [images]="galleryImages()"
        [initialIndex]="galleryStartIndex()"
        (close)="showFullScreen.set(false)"
    />
}

<!-- Data da imagem (paridade com o app) -->
@if (showDateModal())
{
    <modal-image-date
        [date]="getCurrentField().date"
        (save)="onSaveImageDate($event)"
        (close)="showDateModal.set(false)"
    />
}

